export default __webpack_public_path__ + "b43b435a237508b83afdafcdbd25119e.png";